module.exports = __webpack_public_path__ + "img/dashboard-logo-bg.62cf1444.png";